import styles from "./TrustedSchools.module.css";
// Import school images
import img13 from "../../assets/images/schoolsWhotrust/img13.jpg";
import img14 from "../../assets/images/schoolsWhotrust/img14.jpg";
import img15 from "../../assets/images/schoolsWhotrust/img15.jpg";
import img16 from "../../assets/images/schoolsWhotrust/img16.jpg";
import img17 from "../../assets/images/schoolsWhotrust/img17.jpg";
import img18 from "../../assets/images/schoolsWhotrust/img18.jpg";
import img19 from "../../assets/images/schoolsWhotrust/img19.jpg";
import img20 from "../../assets/images/schoolsWhotrust/img20.jpg";
import img21 from "../../assets/images/schoolsWhotrust/img21.jpg";
import img22 from "../../assets/images/schoolsWhotrust/img22.jpg";
import img23 from "../../assets/images/schoolsWhotrust/img23.jpg";
import img24 from "../../assets/images/schoolsWhotrust/img24.jpg";
import img25 from "../../assets/images/schoolsWhotrust/img25.jpg";
import img26 from "../../assets/images/schoolsWhotrust/img26.jpg";
import img27 from "../../assets/images/schoolsWhotrust/img27.jpg";
import img28 from "../../assets/images/schoolsWhotrust/img28.jpg";
import img29 from "../../assets/images/schoolsWhotrust/img29.jpg";
import img30 from "../../assets/images/schoolsWhotrust/img30.jpg";
import img31 from "../../assets/images/schoolsWhotrust/img31.jpg";
import img32 from "../../assets/images/schoolsWhotrust/img32.jpg";
import img33 from "../../assets/images/schoolsWhotrust/img33.jpg";
import img34 from "../../assets/images/schoolsWhotrust/img34.jpg";
import img35 from "../../assets/images/schoolsWhotrust/img35.jpg";
import img36 from "../../assets/images/schoolsWhotrust/img36.jpg";
import img37 from "../../assets/images/schoolsWhotrust/img37.jpg";
import img38 from "../../assets/images/schoolsWhotrust/img38.jpg";
import img39 from "../../assets/images/schoolsWhotrust/img39.jpg";
import img40 from "../../assets/images/schoolsWhotrust/img40.jpg";
import img41 from "../../assets/images/schoolsWhotrust/img41.jpg";
import img42 from "../../assets/images/schoolsWhotrust/img42.jpg";
import img43 from "../../assets/images/schoolsWhotrust/img43.jpg";
import img44 from "../../assets/images/schoolsWhotrust/img44.jpg";
import img45 from "../../assets/images/schoolsWhotrust/img45.jpg";
import img46 from "../../assets/images/schoolsWhotrust/img46.jpg";
import img47 from "../../assets/images/schoolsWhotrust/img47.jpg";
import img48 from "../../assets/images/schoolsWhotrust/img48.jpg";
import img49 from "../../assets/images/schoolsWhotrust/img49.jpg";
import img50 from "../../assets/images/schoolsWhotrust/img50.jpg";
import img51 from "../../assets/images/schoolsWhotrust/img51.jpg";
import img52 from "../../assets/images/schoolsWhotrust/img52.jpg";
import img53 from "../../assets/images/schoolsWhotrust/img53.jpg";
import img54 from "../../assets/images/schoolsWhotrust/img54.jpg";
import img55 from "../../assets/images/schoolsWhotrust/img55.jpg";
import img56 from "../../assets/images/schoolsWhotrust/img56.jpg";
import img57 from "../../assets/images/schoolsWhotrust/img57.jpg";
import img58 from "../../assets/images/schoolsWhotrust/img58.jpg";
import img59 from "../../assets/images/schoolsWhotrust/img59.jpg";
import img60 from "../../assets/images/schoolsWhotrust/img60.jpg";
import img61 from "../../assets/images/schoolsWhotrust/img61.jpg";
import img62 from "../../assets/images/schoolsWhotrust/img62.jpg";
import img63 from "../../assets/images/schoolsWhotrust/img63.jpg";

const TrustedSchools = () => {
  const schoolImages = [
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
    img40,
    img41,
    img42,
    img43,
    img44,
    img45,
    img46,
    img47,
    img48,
    img49,
    img50,
    img51,
    img52,
    img53,
    img54,
    img55,
    img56,
    img57,
    img58,
    img59,
    img60,
  ];

  return (
    <section className={styles.trustedSchools}>
      <div className={styles.container}>
        <h2 className={styles.title} data-aos="fade-up">
          Schools Who Trust Us Across India
        </h2>
        <div className={styles.gridContainer}>
          {schoolImages.map((image, index) => (
            <div
              key={index}
              className={styles.schoolCard}
              data-aos="fade-up"
              data-aos-delay={(index % 10) * 100}
            >
              <img
                src={image}
                alt={`Trusted School ${index + 1}`}
                className={styles.schoolImage}
              />
            </div>
          ))}
          <h2 className={styles.subtitle} data-aos="fade-up">
            ...and many more
          </h2>
        </div>

        <div className={styles.government}>
          <h2 className={styles.title} data-aos="fade-up">
            Governments
          </h2>
          <div className={styles.GovernmentImages}>
            <div className={styles.governmentImageWrapper}>
              <img
                src={img61}
                alt="Government Of Karnataka"
                className={`${styles.schoolImage} ${styles.governmentImage}`}
              />
              <h3>Government Of Karnataka</h3>
            </div>
            <div className={styles.governmentImageWrapper}>
              <img
                src={img62}
                alt="Government Of Andhra Pradesh"
                className={`${styles.schoolImage} ${styles.governmentImage}`}
              />
              <h3>Government Of Andhra Pradesh</h3>
            </div>
            <div className={styles.governmentImageWrapper}>
              <img
                src={img63}
                alt="Government Of Telangana"
                className={`${styles.schoolImage} ${styles.governmentImage}`}
              />
              <h3>Government Of Telangana</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedSchools;
